import { Controller } from '@hotwired/stimulus';

// Description: This controller toggles password visibility in form inputs.
// The toggle switches between 'password' and 'text' input types and updates the icon.
//
// Configuration values:
// - data-password-visibility-show-icon-class-value: CSS class for the "show password" icon (default: "fa fa-eye")
// - data-password-visibility-hide-icon-class-value: CSS class for the "hide password" icon (default: "fa fa-eye-slash")
// - data-password-visibility-show-tooltip-value: Tooltip text when password is hidden (default: "Show password")
// - data-password-visibility-hide-tooltip-value: Tooltip text when password is visible (default: "Hide password")
//
// Example usage:
// <div data-controller="password-visibility">
//   <input type="password" data-password-visibility-target="input">
//   <button type="button" data-action="click->password-visibility#toggle" data-password-visibility-target="button">
//     <i data-password-visibility-target="icon" class="fa fa-eye"></i>
//   </button>
// </div>

export default class extends Controller {
  static targets = ['input', 'icon', 'button'];

  static values = {
    showIconClass: { type: String, default: 'fa fa-eye' },
    hideIconClass: { type: String, default: 'fa fa-eye-slash' },
    showTooltip: { type: String, default: 'Show password' },
    hideTooltip: { type: String, default: 'Hide password' }
  }

  connect() {
    this.visible = false;
    this.updateIcon();
    this.updateTooltip();
  }

  toggle(event) {
    event.preventDefault();
    this.visible = !this.visible;
    this.inputTarget.type = this.visible ? 'text' : 'password';
    this.updateIcon();
    this.updateTooltip();
  }

  updateIcon() {
    if (this.hasIconTarget) {
      this.iconTarget.className = this.visible ? this.hideIconClassValue : this.showIconClassValue;
    }
  }

  updateTooltip() {
    if (this.hasButtonTarget) {
      const tooltipText = this.visible ? this.hideTooltipValue : this.showTooltipValue;
      this.buttonTarget.setAttribute('title', tooltipText);
      this.buttonTarget.setAttribute('data-original-title', tooltipText);
    }
  }
}
